import React from 'react';
import PrivacyPolicy from '../PricvacyPolicy';

const YikjeolBotPrivacyPolicy = () => {

  console.log("YikjeolBot component rendering");
    const appSpecificContent = {
      en: {
        developer: "Developer: 물가의새",
        title: "익절 봇 Privacy Policy",
        lastUpdated: "Last Updated: August 8, 2025",
        collectInfo: "1. Information We Collect",
        collectDescription:
          "In 익절 봇, we collect the following information to provide our automated trading services:",
        collectList: [
          "Trading data including stock symbols, prices, and trading volumes",
          "User preferences for trading strategies and risk management",
          "Account settings and notification preferences",
          "Market analysis data and trading performance metrics"
        ],
        usagePurpose: "2. Purpose of Information Use",
        usageDescription: "Your information helps us to:",
        usageList: [
          "Provide automated trading recommendations",
          "Execute trading strategies based on user preferences",
          "Deliver relevant trading notifications and alerts",
          "Improve trading algorithms through performance analysis"
        ],
        dataSharing: "3. Data Sharing & Third-Party Disclosure",
        sharingDescription:
          "익절 봇 does not share personal trading data with third parties. Anonymous, aggregated trading statistics may be shared with analytics partners to improve our services.",
        dataStorage: "4. Data Retention & Deletion",
        storageDescription:
          "Your trading data is stored securely for as long as you maintain an active account. You can export or delete your data at any time through the app settings.",
        contact: "5. Contact",
        contactDescription: "For any privacy-related inquiries about 익절 봇, please contact uiouij1011@gmail.com",
        changeLang: "Change to Korean",
      },
      ko: {
        developer: "개발자: 물가의새",
        title: "익절봇 개인정보처리방침",
        lastUpdated: "최종 업데이트 날짜: 2025년 8월 8일",
        collectInfo: "1. 수집하는 정보",
        collectDescription:
          "익절봇에서는 자동 매매 서비스를 제공하기 위해 다음 정보를 수집합니다:",
        collectList: [
          "주식 종목, 가격, 거래량을 포함한 거래 데이터",
          "매매 전략 및 리스크 관리에 대한 사용자 환경설정",
          "계정 설정 및 알림 환경설정",
          "시장 분석 데이터 및 매매 성과 지표"
        ],
        usagePurpose: "2. 정보 이용 목적",
        usageDescription: "수집된 정보는 다음 목적으로 이용됩니다:",
        usageList: [
          "자동 매매 추천 서비스 제공",
          "사용자 설정에 따른 매매 전략 실행",
          "관련 매매 알림 및 경고 전달",
          "성과 분석을 통한 매매 알고리즘 개선"
        ],
        dataSharing: "3. 정보의 공유 및 제3자 제공",
        sharingDescription:
          "익절봇은 개인 매매 정보를 제3자와 공유하지 않습니다. 서비스 개선을 위해 익명화된 집계 매매 통계는 분석 파트너와 공유될 수 있습니다.",
        dataStorage: "4. 정보의 보존 및 삭제",
        storageDescription:
          "매매 정보는 계정이 활성화되어 있는 동안 안전하게 보관됩니다. 앱 설정을 통해 언제든지 정보를 내보내거나 삭제할 수 있습니다.",
        contact: "5. 연락처",
        contactDescription: "익절봇과 관련된 개인정보보호 문의는 uiouij1011@gmail.com으로 연락 주세요.",
        changeLang: "영어로 변경",
      },
    };

  return <PrivacyPolicy customContent={appSpecificContent} />;
};

export default YikjeolBotPrivacyPolicy;